/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useMemo } from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { isWeb } from '@global/screens';
import Image from '@components/global/Image';

const hamburger = {
  width: 25,
  height: 25,
};

const HamburgerButton = (props) => {
  const toggleDrawer = () => {
    props.navigation.toggleDrawer();
  };

  const ButtonItem = useMemo(() => {
    return !isWeb ? (
      <View style={{ flexDirection: 'row' }}>
        <TouchableOpacity onPress={() => toggleDrawer()}>
          <Image
            key="hamburgerStyle"
            width={hamburger.width}
            height={hamburger.height}
            style={styles.hamburgerStyle}
            svg={true}
            source={require('@assets/img/icons/hamburger.svg')}
          />
        </TouchableOpacity>
      </View>
    ) : (
      false
    );
  }, []);

  return ButtonItem;
};

const styles = StyleSheet.create({
  hamburgerStyle: {
    width: hamburger.width,
    height: hamburger.height,
    marginLeft: 15,
  },
});

export default React.memo(HamburgerButton, (prev, next) => prev == next);
